import clsx from "clsx";
import { useId, type ReactNode } from "react";

/** A titled workbench panel; `min-w-0` keeps wide content from stretching the grid. */
export function Panel({
  title,
  children,
  className,
}: {
  title: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  const id = useId();
  return (
    <section aria-labelledby={id} className={clsx("surface print-plain min-w-0 p-4", className)}>
      <h2 id={id} className="mb-3 font-display text-lg text-ink-900 dark:text-ink-50">
        {title}
      </h2>
      <div className="space-y-4">{children}</div>
    </section>
  );
}
